export default __webpack_public_path__ + "static/media/0057.3a973ecc.png";